<template>
    <div class="sidebar" :class="{ collapsed }">
        <div class="sidebar-logo">
            <router-link class='no-underline logo-link' to="/">
                <div class="logo-img"><span>KYCWISE</span></div>
            </router-link>
            <button class="sidebar-toggle" @click="toggleCollapsed"
                    :title="collapsed ? 'Expand sidebar' : 'Collapse sidebar'"
                    :aria-label="collapsed ? 'Expand sidebar' : 'Collapse sidebar'">
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                     stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                    <rect x="3" y="4" width="18" height="16" rx="3"/>
                    <line x1="9" y1="4" x2="9" y2="20"/>
                    <polyline :points="collapsed ? '13.5 9.5 16 12 13.5 14.5' : '16 9.5 13.5 12 16 14.5'"/>
                </svg>
            </button>
        </div>
        <div class="sidebar-nav">
        <div class='sidebar_item no-height' v-if="user && user.is_super_user">
            <span class="link-item pointer " @click="toggleGroup('admin')" title="Admin">
                <img src="@/assets/arrow-opener.svg" class="arrow-opener" :class="openGroups.admin ? 'opened': ''">
                <div class="image-place">
                    <img src="@/assets/admin.svg">
                </div>
                <div class="text relative">
                    Admin 

                    <div v-if="pendingAgreements?.length" class="amount-of-items" style="top: 0px; left: 50px">
                        {{ pendingAgreements?.length }}
                    </div>
                </div>
            </span> 
            <div v-if="openGroups.admin">
                <div class='left-nav'>
                    <div class=''>
                        <router-link :title="collapsed ? 'Users' : null" class='link-item' :to="{name: 'bo_users'}"><div class="text">Users</div></router-link>
                    </div>
                    <div class=''>
                        <router-link :title="collapsed ? 'Invoices' : null" class='link-item with-image' :to="{name: 'bo_invoices'}">
                            <div class="image-place">
                                <img src="@/assets/invoice.svg">
                            </div>
                            <div class="text">Invoices</div>
                        </router-link>
                    </div>
                    <div class=''>
                        <router-link :title="collapsed ? 'Dashboard' : null" class='link-item' :to="{name: 'dashboard'}"><div class="text">Dashboard</div></router-link>
                    </div>
                    <div class=''>
                        <router-link :title="collapsed ? 'FIU Templates' : null" class='link-item with-image' :to="{name: 'fiu-templates'}">
                            <div class="image-place">
                                <img src="@/assets/template.svg">
                            </div>
                            <div class="text">FIU Templates</div>
                        </router-link>
                    </div>
                    
                    <div class=''>
                        <router-link :title="collapsed ? 'Platform Control' : null" class='link-item' :to="{name: 'platform-control'}">
                            <div class="text">Platform Control</div>
                        </router-link>
                    </div>
                    <div class=''>
                        <router-link :title="collapsed ? 'Currency Rates' : null" class='link-item' :to="{name: 'currency_rates'}">
                            <div class="text">Currency Rates</div>
                        </router-link>
                    </div>
                    <div class="relative">
                        <router-link :title="collapsed ? 'Pending Agreements' : null" class='link-item' :to="{name: 'agreements'}">
                            <div class="text">
                                Pending Agreements
                                <div v-if="pendingAgreements?.length" class="amount-of-items" style="top: 8px">
                                    {{ pendingAgreements?.length }}
                                </div>
                            </div>
                        </router-link>
                    </div>
                    <div class=''>
                        <router-link :title="collapsed ? 'Page Countent' : null" class='link-item' :to="{name: 'terms-admin'}"> <div class="text">Page Countent</div></router-link>
                    </div>
                    <div class=''>
                        <router-link :title="collapsed ? 'Logs' : null" class='link-item' :to="{name: 'logs'}"> <div class="text">Logs</div></router-link>
                    </div>
                </div>
            </div>
            <hr>
        </div>


        <div class='sidebar_item no-height' v-if="user && SS_Available && !collapsed">
            <router-link :title="collapsed ? 'Sanction Screening' : null" class='link-item self-determined' :to="`/sanction-screening`"> 
                <!-- <div class="image-place">
                    <img src="@/assets/due-diligence.svg">
                </div> -->
                <div class="text">Sanction Screening</div>
            </router-link>
            <hr>
        </div>
        <div class='sidebar_item no-height' v-if="user && DD_Available">
            <router-link :title="collapsed ? 'Due Diligence' : null" class='link-item self-determined' :to="`/due-diligence`"> 
                <div class="image-place">
                    <img src="@/assets/due-diligence.svg">
                </div>
                <div class="text">Due Diligence</div>
            </router-link>
            <hr>
        </div>



        <div class='sidebar_item no-height' v-if="KYCAvailable">
            <span class="link-item pointer" @click="toggleGroup('kyc')" title="KYC Module">
                <img src="@/assets/arrow-opener.svg" class="arrow-opener" :class="openGroups.kyc ? 'opened': ''">
                <div class="image-place">
                    <img src="@/assets/kyc.svg">
                </div>
                <div class="text">KYC Module</div>
            </span> 
            <div v-if="openGroups.kyc && !collapsed">
                <div class='left-nav'>
                    <div class='sidebar_item' :class="currentPath == '/' ? 'active' : ''">
                        <router-link :title="collapsed ? 'Clients' : null" class='link-item self-determined' to="/kyc/clients"><div class="text">Clients</div></router-link>
                    </div>

                    <router-link :title="collapsed ? 'Due Diligence' : null"  
                        v-if="PermissionChecker.canViewDueDiligence() && companyData && companyData.company_type == 'corporate'" 
                        class='link-item with-image' :to="`/kyc/${companyData ? companyData._id + '/': ''}due-diligence`"
                        > 
                        <img src="@/assets/due-diligence.svg">
                        <div class="text">Due Diligence</div>
                    </router-link>
                    <div class='sidebar_item' v-if="PermissionChecker.viewDashboardSection() && companyData">
                        <router-link :title="collapsed ? 'Dashboard' : null" class='link-item self-determined' :to="`/kyc/${companyData ? companyData._id + '/': ''}`"> <div class="text">Dashboard</div></router-link>
                    </div>
                    <div class='sidebar_item' v-if="PermissionChecker.viewGeneralSection() && companyData && companyData.company_type == 'corporate'">
                        <router-link :title="collapsed ? 'Corporate' : null" class='link-item self-determined' :to="`/kyc/${companyData ? companyData._id + '/': ''}corporate/`"> <div class="text">Corporate</div></router-link>
                    </div>
                    <div class='sidebar_item' v-if="PermissionChecker.viewUboSection() && companyData && companyData.company_type == 'corporate'">
                        <router-link :title="collapsed ? 'Shareholders' : null" class='link-item self-determined' :to="`/kyc/${companyData ? companyData._id + '/': ''}shareholders/`"> <div class="text">Shareholders</div></router-link>
                    </div>

                    
                    <div class='sidebar_item' v-if="PermissionChecker.viewmbdSection() && companyData && companyData.company_type == 'corporate'">
                        <router-link :title="collapsed ? 'Managing Directors' : null" class='link-item self-determined' :to="`/kyc/${companyData ? companyData._id + '/': ''}managing-directors/`"> <div class="text">Managing Directors</div></router-link>
                    </div>
                    <div class='sidebar_item' v-if="companyData && companyData.company_type == 'account_holder'">
                        <router-link :title="collapsed ? 'Account Holder' : null" class='link-item self-determined' :to="`/kyc/${companyData ? companyData._id + '/': ''}account-holder/`"> <div class="text">Account Holder</div></router-link>
                    </div>
                    <div class='sidebar_item' v-if="PermissionChecker.viewTransactionProfile() && companyData && (companyData.transaction_profile_report.new_value || companyData.transaction_profile_report.value) == 'YES'">
                        <router-link :title="collapsed ? 'Transaction Profile' : null" class='link-item self-determined' :to="`/kyc/${companyData ? companyData._id + '/': ''}transaction-profile/`"> <div class="text">Transaction Profile</div></router-link>
                    </div>
                    <div class='sidebar_item' v-if="PermissionChecker.viewSubsidiaries() && companyData">
                        <router-link :title="collapsed ? 'Subsidiary' : null" class='link-item self-determined' :to="`/kyc/${companyData ? companyData._id + '/': ''}subsidiary/`"> <div class="text">Subsidiary</div></router-link>
                    </div>

                    
               
                    <div class='sidebar_item' v-if="PermissionChecker.viewRequestLog()">
                        <router-link :title="collapsed ? 'Work Flow' : null" class='link-item self-determined' :to="`/kyc/${companyData ? companyData._id + '/' : ''}workflow/`"> 
                            <div class="amount-of-items" v-if="notificationsCount">
                                {{ notificationsCount }}
                            </div>
                            <div class="text">Work Flow</div>
                        </router-link>
                    </div>
                    <div class='sidebar_item' v-if="PermissionChecker.viewChangeLog()">
                        <router-link :title="collapsed ? 'Change Log' : null" class='link-item self-determined' :to="`/kyc/${companyData ? companyData._id + '/': ''}change-log/`"> <div class="text">Change Log</div></router-link>
                    </div>
                    <div class='sidebar_item' v-if="PermissionChecker.viewRequestLog()">
                        <router-link :title="collapsed ? 'Tasks' : null" class='link-item self-determined' :to="`/kyc/${companyData ? companyData._id + '/' : ''}tasks/`"> 
                            <div class="text">Tasks</div>
                        </router-link>
                    </div>
                    <div class='sidebar_item' v-if="PermissionChecker.viewDocumentHistory() && companyData">
                        <router-link :title="collapsed ? 'Review History' : null" class="link-item self-determined" :to="`/kyc/${companyData ? companyData._id + '/': ''}document-history/`">
                            <div class="text">Review History</div>
                        </router-link> 
                    </div>
                    <div class='sidebar_item' v-if="PermissionChecker.canDoSnactionScreaning() && companyData && (companyData.sanction_screening_available.new_value || companyData.sanction_screening_available.value) == 'YES'">
                        <router-link :title="collapsed ? 'Sanction History' : null" class="link-item self-determined" :to="`/kyc/${companyData ? companyData._id + '/': ''}sanction-screening-lookups/`">
                            <div class="text">Sanction History</div>
                        </router-link> 
                    </div>
                </div>
            </div>
            <hr>

        </div>
      
        <div class='sidebar_item no-height' v-if="user && fiuAvailable">
            
            <span class="link-item pointer" @click="toggleGroup('fiu')" title="FIU Module">
                <img src="@/assets/arrow-opener.svg" class="arrow-opener" :class="openGroups.fiu ? 'opened': ''">
                <div class="image-place">
                    <img src="@/assets/fiu.svg">

                </div>
                <div class="text">FIU Module</div>
            </span>

            <div v-if="openGroups.fiu || collapsed">
                <div class="left-navs">
                   <div class=''>
                       <router-link :title="collapsed ? 'Dashboard' : null" class="link-item" to="/fiu/user-info">
                           <div class="image-place">
                               <img src="@/assets/user-info.svg">
                           </div>
                           <div class="text">Dashboard</div>
                       </router-link> 
                   </div>
                   <div class=''>
                       <router-link :title="collapsed ? 'Usage Overview' : null" class="link-item" to="/fiu/dashboard">
                           <div class="image-place">
                                <img src="@/assets/usage.svg">
                           </div>
                           <div class="text">Usage Overview</div>
                       </router-link> 
                   </div>
                   <div class=''>
                       <router-link :title="collapsed ? 'Convert' : null" class="link-item" to="/fiu/convert">
                           <div class="image-place">
                                <img src="@/assets/convert.svg" style="margin-left:-3px;">
                           </div>
                           <div class="text">Convert</div>
                       </router-link> 
                   </div>
                   <div class=''>
                       <router-link :title="collapsed ? 'My Files' : null" class="link-item" :class="{ 'router-link-exact-active': currentPath.startsWith('/fiu/drive') }" to="/fiu/drive">
                           <div class="image-place">
                                <img src="@/assets/documents-black.svg" style="opacity: 0.55;">
                           </div>
                           <div class="text">My Files</div>
                       </router-link> 
                   </div>
                   <div class=''>
                       <router-link :title="collapsed ? 'Report List' : null" class="link-item" to="/fiu/reports">
                           <div class="image-place">
                               <img src="@/assets/reports.svg">
                           </div>
                           <div class="text">Report List</div>
                       </router-link> 
                   </div>
                   <div class=''>
                       <router-link :title="collapsed ? 'Upload history' : null" class="link-item" to="/fiu/file-list">
                            <div class="image-place">
                                <img src="@/assets/history_.svg" style="margin-left:-3px;">
                            </div>
                            <div class="text">Upload history</div>
                       </router-link> 
                   </div>

                   <div class=''>
                       <router-link :title="collapsed ? 'Player Data' : null" class="link-item" to="/fiu/player-data">
                           <div class="image-place">
                            <img src="@/assets/crowd.svg" style="margin-left:-3px;">

                           </div>
                           <div class="text">Player Data</div>
                       </router-link> 
                   </div>
                 
                  <div class=''>
                    <router-link :title="collapsed ? 'Templates' : null" class="link-item" to="/fiu/templates">
                        <div class="image-place">
                            <img src="@/assets/template.svg">

                           </div>
                           <div class="text">Templates</div>
                    </router-link> 
                   </div>
                   <!-- <div class='' >
                        <span class="link-item pointer" @click="templatesShown = true">
                            <div class="image-place">
                                <img src="@/assets/template.svg">
                            </div>
                            <div class="text">Templates</div>
                        </span>
                   </div> -->
               </div>
           </div>
            <hr>

       </div>

       <div v-if="PermissionChecker.viewUser()">
            <router-link :title="collapsed ? 'User Management' : null" class="link-item" to="/user-management">
                <div class="image-place">
                    <img src="@/assets/person.svg">
                </div>
                <div class="text">User Management</div>
            </router-link> 
        </div>

       <div>
            <router-link :title="collapsed ? 'Invoices' : null" class="link-item" to="/invoices">
                <div class="image-place">
                    <img src="@/assets/invoice.svg">
                </div>
                <div class="text">Invoices</div>
            </router-link> 
        </div>
        <!-- <div class='sidebar_item'>
            <router-link :title="collapsed ? 'Terms' : null" class="link-item" to="/terms-and-conditions">
                <div class="image-place">
                </div>
                <div class="text">Terms</div>
            </router-link> 
        </div>  
        <div class='sidebar_item'>
            <router-link :title="collapsed ? 'Privacy Policy' : null" class="link-item" to="/privacy-policy">
                <div class="image-place">
                </div>
                <div class="text">Privacy Policy</div>
            </router-link> 
        </div>   -->
        <PopupCover v-if="templatesShown" @close="templatesShown = false" >
            <PopupBody @close="templatesShown = false" style="width: 800px;">
                <template #header>
                    <div class="popup-header">
                        Templates
                    </div>
                </template>

            <template #body>
                    <userFiuTemplates />
            </template>
            </PopupBody>
        </PopupCover>
        </div>
    </div>
</template>

<script setup>

import { useStore } from 'vuex';
import { useRouter, useRoute } from 'vue-router'
import API from '../api/index.js'
import  { PermissionChecker } from '../utils/iam_utils.js'
import { computed, ref, watch, onBeforeUnmount } from 'vue';
import PopupBody from './PopupBody.vue';
import PopupCover from './PopupCover.vue';
import userFiuTemplates from '@/views/userFiuTemplates.vue';

const store = useStore();
const notificationsCount = computed(() => store.state.notificationsCount);
const user = store.state.user;


const companyData = computed(() => store.state.companyData);
const fiuAvailable = computed(() => store.getters.FIU_Available);
const KYCAvailable = computed(() => store.getters.KYC_Available);
const DD_Available = computed(() => store.getters.DD_Available);
const SS_Available = computed(() => store.getters.SS_Available);

const openGroups = ref({ kyc: true, fiu: true, admin: false });

const COLLAPSED_WIDTH = '72px';
const EXPANDED_WIDTH = '250px';

const collapsed = computed(() => store.state.sidebarCollapsed);

function applyWidth() {
    document.documentElement.style.setProperty('--sidebar-width', collapsed.value ? COLLAPSED_WIDTH : EXPANDED_WIDTH);
}

function toggleCollapsed() {
    store.commit('toggleSidebar');
}

function toggleGroup(name) {
    if (collapsed.value) {
        // in collapsed mode, clicking a group icon expands the sidebar with that group open
        openGroups.value[name] = true;
        toggleCollapsed();
        return;
    }
    openGroups.value[name] = !openGroups.value[name];
}

watch(collapsed, applyWidth, { immediate: true });
onBeforeUnmount(() => document.documentElement.style.removeProperty('--sidebar-width'));

const templatesShown = ref(false);

const pendingAgreements = computed(() => store.state.pendingAgreements);


const route = useRoute();
const view = computed(() => route.query.view);
const currentPath = computed(() => route.path);
</script>

<style scoped lang="scss">
    .sidebar {
        background-color: white;
        width: var(--sidebar-width);
        position: fixed;
        top: 0;
        box-sizing: border-box;
        bottom: 0;
        left: 0;
        // Below dialogs/popups (Popup, PopupCover, newPopup all use 1000)
        z-index: 999;
        display: flex;
        flex-direction: column;
        overflow: hidden;
        transition: width 0.2s ease;
    }
    .sidebar-logo {
        height: 60px;
        flex-shrink: 0;
        box-sizing: border-box;
        border-bottom: 1px solid var(--border-color);
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 12px 0 28px;
        position: relative;
        transition: padding 0.2s ease;
    }
    .sidebar-toggle {
        width: 38px;
        height: 38px;
        padding: 0;
        flex-shrink: 0;
        border-radius: 10px;
        background: transparent;
        color: var(--sidebar-text-color);
        display: flex;
        align-items: center;
        justify-content: center;
        &:hover {
            background: rgb(236 240 255);
            color: var(--primary-color);
        }
    }
    .sidebar-nav {
        flex: 1;
        border-right: 0.5px solid var(--border-color);
        min-height: 0;
        padding: 20px;
        padding-left: 15px;
        overflow-x: hidden;
        overflow-y: auto;
    }
    .text {
        white-space: nowrap;
    }
    .sidebar.collapsed {
        .sidebar-logo {
            padding: 0;
            justify-content: center;
        }
        /* collapsed: logo shown; hovering the logo row swaps it for the expand button */
        .sidebar-toggle {
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
            opacity: 0;
            pointer-events: none;
        }
        .sidebar-logo:hover {
            .logo-link { opacity: 0; pointer-events: none; }
            .sidebar-toggle { opacity: 1; pointer-events: auto; }
        }
        .sidebar-nav {
            padding-left: 10px;
            padding-right: 10px;
        }

        .text, .arrow-opener {
            display: none;
        }
        a.link-item, .link-item {
            justify-content: center;
            padding-left: 0;
            margin-left: 0;
            gap: 0;
        }
        .left-nav a:not(.with-image) {
            display: none;
        }
    }
    .sidebar_item:not(.no-height) {
        height: 40px;
    }
    .text {
        color: rgb(116 119 127);
        font-size: 15px;
    }
    .image-place {
        width: 25px;
        height: 25px;
        padding-bottom: 3px;

        img {
            width: 100%;
            height: 100%;
        }
    }
    
    a.link-item, .link-item {
        height: 40px;
        text-decoration: none;
        display: flex;
        align-items: center;
        gap: 10px;
        font-weight: bold;
        color: var(--sidebar-text-color);
        border-radius: 1.5rem;
        padding-left: 13px;
        cursor: pointer;
        &.router-link-exact-active {
            .text {
                color: var(--primary-color); 
            }
            position: relative;
            background-color: rgb(236 240 255);
        }
        &.pointer {
            padding-left: 0;
            margin-left: -5px;
        }
    }
    .active a[class] {
        .text {
            color: var(--primary-color); 
        }
        position: relative;
        background-color: rgb(236 240 255);
    }
    .left-nav {
        a:not(.with-image) {
            padding-left: 45px;
        }
    }
    .arrow-opener {
        transition: 0.3s all;
    }
    .opened {
        transform: rotate(90deg);
    }
    .link-item {
        position: relative;
    }
    .amount-of-items {
        background: var(--primary-color);
        color: white;
        border-radius: 50%;
        width: 20px;
        height: 20px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 12px;
        position: absolute;
        left: 10px;
    }

</style>